import React from 'react';
import PropTypes from 'prop-types';
import { CloseModalHotkey } from '../hotkeys/close-modal';
import { noop } from 'ui-components/default-props/noop';

export const Hotkeys = ({ children, onClose = noop }) => <CloseModalHotkey onClose={onClose}>{children}</CloseModalHotkey>;

Hotkeys.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
};
